// eslint-disable-next-line no-restricted-imports
import { GlobalFinancialMonitoringInfoPartTwoDto_Input } from 'api/generated/graphql';
import { LegalClientSaveGlobalFinancialMonitoringPartTwoParam } from 'api/types/params';

export const parseLegalClientSaveGlobalFinancialMonitoringPartTwoParam = (
  data: LegalClientSaveGlobalFinancialMonitoringPartTwoParam
): GlobalFinancialMonitoringInfoPartTwoDto_Input => ({
  hasSourceOfFundsProcedures: data.hasSourceOfFundsProcedures,
  hasRelationshipsWithPEPProcedures: data.hasRelationshipsWithPEPProcedures,
  hasAnonymousAccounts: data.hasAnonymousAccounts,
  hasAnonymousAccountPreventionProcedures:
    data.hasAnonymousAccountPreventionProcedures,
  hasTransactionMonitoringProcedures: data.hasTransactionMonitoringProcedures,
  hasAssetFreezingProcedures: data.hasAssetFreezingProcedures,

  hasAMLTrainingProcedures: data.hasAMLTrainingProcedures,
  amlTrainingDetails: data.amlTrainingDetails,

  hasBranchesInNonFATFCountries: data.hasBranchesInNonFATFCountries,
  nonFATFBranchesNamesAndLocations: data.nonFATFBranchesNamesAndLocations,

  hasCorrespondentsInNonFATFCountries: data.hasCorrespondentsInNonFATFCountries,
  nonFATFCorrespondentsNames: data.nonFATFCorrespondentsNames,

  hasCorrespondentsInOffshoreZones: data.hasCorrespondentsInOffshoreZones,
  offshoreCorrespondentsNames: data.offshoreCorrespondentsNames,

  hasShellBankRelationships: data.hasShellBankRelationships,
  shellBanksNames: data.shellBanksNames,

  hasShellBankPreventionProcedures: data.hasShellBankPreventionProcedures,
  hasCDDRequestComplianceProcedures: data.hasCDDRequestComplianceProcedures,

  creditRating: data.creditRating,
  subsidiariesNamesAndLocations: data.subsidiariesNamesAndLocations,
  keyPartnersNames: data.keyPartnersNames,
  foreignBranchesNamesAndLocations: data.foreignBranchesNamesAndLocations,
  financialGroupInfo: data.financialGroupInfo,

  hasSanctionPolicyDocuments: data.hasSanctionPolicyDocuments,
  hasSanctionsMonitoringProcedures: data.hasSanctionsMonitoringProcedures,
  isUnderSanctionsOrControlledBySanctionedEntity:
    data.isUnderSanctionsOrControlledBySanctionedEntity,
  isListedInSanctionLists: data.isListedInSanctionLists,
  isLinkedToSanctionedEntities: data.isLinkedToSanctionedEntities,
});
